/**
 * The add-in's panel cache (outlook-orachat-uplift s9, Q1).
 *
 * Chat history stays in memory for this page, including across the
 * permission reload's in-page remount only when the same document lives.
 * A real document reload constructs a new store, so nothing from before
 * the reload is read back from disk. The boot clears it on uninstall.
 */

function createMemoryStorage(): Storage {
  const data = new Map<string, string>();
  return {
    get length() {
      return data.size;
    },
    clear() {
      data.clear();
    },
    getItem(key: string) {
      return data.has(key) ? data.get(key)! : null;
    },
    key(index: number) {
      return Array.from(data.keys())[index] ?? null;
    },
    removeItem(key: string) {
      data.delete(key);
    },
    setItem(key: string, value: string) {
      data.set(key, String(value));
    },
  };
}

/** The one store `bootOraChat` installs into the panel. */
export const paneMemoryStore: Storage = createMemoryStorage();
